import { NewslettersType, RequestNewslettersType } from 'b2b-common/core/account/api/Newsletters.types';
import {
  CLEAR_ACCOUNT_NEWSLETTERS,
  CLEAR_UPDATE_ACCOUNT_NEWSLETTERS,
  FETCH_NEWSLETTERS,
  FETCH_NEWSLETTERS_FULFILLED,
  FETCH_NEWSLETTERS_REJECTED,
  UPDATE_NEWSLETTERS,
  UPDATE_NEWSLETTERS_FULFILLED,
  UPDATE_NEWSLETTERS_REJECTED,
} from './actionTypes';
import {
  ClearAccountNewslettersAction,
  ClearUpdateNewslettersAction,
  FetchNewslettersAction,
  FetchNewslettersFulfilledAction,
  FetchNewslettersRejectedAction,
  UpdateNewslettersAction,
  UpdateNewslettersFulfilledAction,
  UpdateNewslettersRejectedAction,
} from './types';

const fetchNewsletters = (): FetchNewslettersAction => ({
  type: FETCH_NEWSLETTERS,
});

const fetchNewslettersFulfilled = (response: NewslettersType): FetchNewslettersFulfilledAction => ({
  type: FETCH_NEWSLETTERS_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchNewslettersRejected = (error: ErrorType): FetchNewslettersRejectedAction => ({
  type: FETCH_NEWSLETTERS_REJECTED,
  payload: {
    error,
  },
});

const updateNewsletters = (newsletters: RequestNewslettersType): UpdateNewslettersAction => ({
  type: UPDATE_NEWSLETTERS,
  payload: {
    newsletters,
  },
});

const updateNewslettersFulfilled = (): UpdateNewslettersFulfilledAction => ({
  type: UPDATE_NEWSLETTERS_FULFILLED,
});

const updateNewslettersRejected = (
  error: ErrorType,
): UpdateNewslettersRejectedAction => ({
  type: UPDATE_NEWSLETTERS_REJECTED,
  payload: {
    error,
  },
});

const clearUpdateNewsletters = (): ClearUpdateNewslettersAction => ({
  type: CLEAR_UPDATE_ACCOUNT_NEWSLETTERS,
});

const clearAccountNewsletters = (): ClearAccountNewslettersAction => ({
  type: CLEAR_ACCOUNT_NEWSLETTERS,
});

export {
  clearAccountNewsletters,
  clearUpdateNewsletters,
  fetchNewsletters,
  fetchNewslettersFulfilled,
  fetchNewslettersRejected,
  updateNewsletters,
  updateNewslettersFulfilled,
  updateNewslettersRejected,
};
